import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { OpenIncidentController } from '@shared/src/controllers/open/openincident.controller';
import { IncidentStateDto } from '@shared/src/dtos/incident/IncidentStateDto';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { RouteCMRAgentActionsDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentActionsDto';
import { RouteCMRAgentPhaseExpandBaseDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentPhaseExpandBaseDto';
import { AlertService, HString, SharedExternalCMRAgentActionsPoliceInspectionComponent, SharedExternalCMRAgentPhaseECMRsDigitalDocumentComponent } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-agent-actions',
    templateUrl: './shared.external.cmr.agent.actions.component.html',
    styleUrls: ['./shared.external.cmr.agent.actions.component.scss']
})
export class SharedExternalCMRAgentActionsComponent implements OnInit {


    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        public openIncidentController: OpenIncidentController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
    }

    public __uuidQR: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.loadData();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }

    public __agent: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.__agent === value)
            return;
        this.__agent = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.__agent;
    }

    public value: RouteCMRAgentActionsDto;
    loadData() {
        if (!HString.isNullOrNullString(this.uuidQR) && RouteCMRAgentsEnum.isValid(this.agent)) {
            this.openRouteCMRController.getRouteCMRAgentActionsCtrlByUUID(this.uuidQR, this.agent).subscribe(data => { 
                this.wellcome(data);
            });
            this.loadIncidentState();
        }
    }
    /** Estat de les incidències: només el conductor pot informar d'un problema i indicar que està parat */
    public incidentState: IncidentStateDto;
    public loadIncidentState(): void {
        this.openIncidentController.getIncidentState(null, this.uuidQR, this.agent).subscribe(data => {
            this.incidentState = data;
        });
    }

    public canReportIncident(): boolean {
        return this.incidentState != null && this.incidentState.canReport;
    }

    public isStandStill(): boolean {
        return this.incidentState != null && this.incidentState.iStandStill;
    }

    /** En tornar d'informar d'un problema o d'estic parat */
    public onIncidentDone(): void {
        this.loadIncidentState();
        this.collapse();
    }

    public wellcome(value: RouteCMRAgentActionsDto) {
        this.value = value;
        this.loadPhases();
    }

    public phases: RouteCMRAgentPhaseExpandBaseDto[];
    public getPhases(){
        if(this.phases == null)
            return new Array();
        return this.phases;
    }
    public loadPhases(){
        this.phases = new Array();
        if(this.value == null || this.value.phases == null)
            return;
        this.value.phases.forEach(phase => {
            if((phase.isLoad && !phase.isSignedDriver) || (phase.isUnload && !phase.isSignedConsignee))
                this.phases.push(phase);
        });
    }

    public phaseUUID: string;
    public goToPhase(phase: RouteCMRAgentPhaseExpandBaseDto){
        this.phaseUUID = phase ? phase.uuid : "";
        if(phase != null){
            this.onClickLinkAction('Phase');
        }
    }
    
    public actionExpanded: string = "";

    onClickLinkAction(option: string) {

        if (option == this.actionExpanded) {
            //Estem tancat l'opció oberta
            this.actionExpanded = "";
            return;
        }
        
        this.actionExpanded = option;
    }

    @ViewChild(SharedExternalCMRAgentActionsPoliceInspectionComponent) policeInspectorComponent: SharedExternalCMRAgentActionsPoliceInspectionComponent;
    @ViewChild(SharedExternalCMRAgentPhaseECMRsDigitalDocumentComponent) phaseComponent: SharedExternalCMRAgentPhaseECMRsDigitalDocumentComponent;

    public collapse(): boolean {
        if (this.actionExpanded) {
            if(this.actionExpanded == 'PoliceInspection' && this.policeInspectorComponent?.collapse())
                return true;
            if(this.actionExpanded == 'Phase' && this.phaseComponent?.collapse())
                return true;
            
            this.actionExpanded = "";
            return true;
        }
        return false;
    }

    public onAllPhaseSigned(value: boolean){
        if(value){
            this.loadData();
            this.collapse();
        }
    }

    public getResourcePhase(phase: RouteCMRAgentPhaseExpandBaseDto): string{
        if(phase == null || phase.isLoad)
            return 'SHARED.EXTERNAL.CMR.ACTIONS.UNLOADPHASE.CAPTION';
        return 'SHARED.EXTERNAL.CMR.ACTIONS.LOADPHASE.CAPTION';
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
